import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  fixtureURL,
  homepageURL,
  mediaURL,
  scoreURL,
  singamsTvURL,
  squadURL,
  statsURL,privacyURL,termURL
} from "./components/helpers/constant-words";
import Homepage from "./pages/Homepage/Homepage";
import Fixture from "./pages/Fixture/Fixture";
import Score from "./pages/Score/Score";
import Squad from "./pages/Squad/Squad";
import Stats from "./pages/Stats/Stats";
import Media from "./pages/Media/Media";
import SingamsTv from "./pages/SingamsTv/SingamsTv";
import Privacy from "./pages/Privacy/Privacy";
import Term from "./pages/Term/Term";
const Routing = () => {
  return (
    <>
      <Routes>
        <Route path={homepageURL} element={<Homepage />} />
        <Route path={fixtureURL} element={<Fixture />} />
        <Route path={scoreURL} element={<Score />} />
        <Route path={squadURL} element={<Squad />} />
        <Route path={statsURL} element={<Stats />} />
        <Route path={mediaURL} element={<Media />} />
        <Route path={singamsTvURL} element={<SingamsTv />} />
	<Route path={privacyURL} element={<Privacy />} />
        {/* <Route exact path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} /> */}
	 <Route path={termURL} element={<Term />} />
      </Routes>
    </>
  );
};
export default Routing;
